import script from "./MTActiveClientsPage.vue?vue&type=script&setup=true&lang=js"
export * from "./MTActiveClientsPage.vue?vue&type=script&setup=true&lang=js"

import "./MTActiveClientsPage.vue?vue&type=style&index=0&id=6c581158&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c581158"]])

export default __exports__